import { useEffect } from 'react';

import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';

import { Grid } from '@mui/material';
import { Encabezado } from '../../Components/Encabezado/Encabezado';
import EncuestaCard from '../../Components/Encuesta/EncuestaCard';
import Loading from '../../Components/Modals/Loading/Loader';
import {
  fetchBuscarEncuestas,
  fetchCambiarSuccess,
  selectEncuestas,
  selectIsLoading,
  selectIsSuccess,
  selectMessage,
} from './../../redux/Encuestas/EncuestasSlice';

import swal from 'sweetalert';

export const Encuestas = () => {
  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  const isLoading = useSelector(selectIsLoading);
  const isSuccess = useSelector(selectIsSuccess);
  const message = useSelector(selectMessage);
  const encuestas = useSelector(selectEncuestas);

  useEffect(() => {
    if (!encuestas || Object.keys(encuestas).length === 0) {
      dispatch(fetchBuscarEncuestas());
    }
  }, []);

  useEffect(() => {
    if (isSuccess === 'success' && message?.length > 0) {
      swal('Exitoso!', message, 'success');

      // * LIMPIAR
      dispatch(fetchBuscarEncuestas());
      dispatch(fetchCambiarSuccess());
    } else if (isSuccess === 'error' && message?.length > 0) {
      swal('Error!', message, 'error');
      dispatch(fetchCambiarSuccess());
    }
  }, [isSuccess, message]);

  return (
    <Encabezado title="ENCUESTAS">
      <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
        {/* <Button variant='contained'>
            Crear encuesta
            </Button> */}
      </Box>
      <Box>
        <Grid container spacing={2} alignItems="stretch" justifyContent="center">
          {encuestas &&
            encuestas.length > 0 &&
            encuestas.map((encuesta, index) => (
              <Grid item xs={'auto'} sm={'auto'} md={'auto'} key={index} sx={{ display: 'flex', height: '100%' }}>
                <EncuestaCard encuesta={encuesta} />
              </Grid>
            ))}
        </Grid>
      </Box>

      <Loading open={isLoading} />
    </Encabezado>
  );
};
